// extracted by mini-css-extract-plugin
module.exports = {"root":"PolicyManagement_root__FGlAi","ui":"PolicyManagement_ui__atiah","code":"PolicyManagement_code__QshsA"};